import { Camera } from 'react-bytesize-icons';
import capojs from "../../../../assets/images/docs/meta/capo.png";
import metaOverview from "../../../../assets/images/docs/meta/meta-overview.png";
import missingtags from "../../../../assets/images/docs/meta/missingtags.png";
import sortableSocials from "../../../../assets/videos/docs/meta/sortable-socials.mp4";
import * as React from 'react';
export default {
  Camera,
  capojs,
  metaOverview,
  missingtags,
  sortableSocials,
  React
};